import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async login(username, password, branch) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/tokens/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data: { username, password, branch } });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updatePassword(data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/users/password/',
      method: HttpMethod.PUT
    };

    try {
      const res = await processRequest(ep, { data });

      const result = processSuccessResponse(res);

      return result;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async refreshToken(token) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/access-tokens/',
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data: { refreshToken: token } });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getProfile() {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v1/me/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
